import {useSearchParams} from "react-router-dom";
import {QueryParamConfig} from "use-query-params";
import {useCallback, useMemo, useState} from "react";

export {NumberParam, StringParam, withDefault, BooleanParam} from "use-query-params";

export const useQueryParam = <D, D2 = D>(key: string, config?: QueryParamConfig<D, D2>): [D2, (value: D, replace?: boolean) => any] => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [firstRun, setFirstRun] = useState(true)

    const value = useMemo(() => config?.decode(searchParams.get(key)) ?? searchParams.get(key), [config, key, searchParams])
    const [previousValue, setPreviousValue] = useState<D>()
    const setValue = useCallback((newValue: D, replace?: boolean) => {
        if (!firstRun) {
            // @ts-ignore
            if (config?.equals?.(previousValue, newValue)) {
                return;
                // @ts-ignore
            } else if (previousValue === newValue) {
                return;
            }
        } else {
            setFirstRun(false)
        }
        setPreviousValue(newValue)
        const searchParamsEntries = Object.fromEntries(searchParams)
        // @ts-ignore
        const encodedValue = config?.encode(newValue) ?? (newValue?.['toString'] ? newValue.toString() : null);
        if (typeof encodedValue === 'string') {
            searchParamsEntries[key] = encodedValue
        } else {
            delete searchParamsEntries[key];
        }
        setSearchParams(new URLSearchParams(searchParamsEntries), {replace: firstRun || replace})
    }, [config, firstRun, key, previousValue, searchParams, setSearchParams])

    // @ts-ignore
    return [value, setValue];
}
